import React from "react";
import {useMediaQuery, useTheme,} from "@mui/material";
import styles from './spots-item.module.css'
import CTAButton from "../../../common/v2/CTA-Button/cta-button";


interface SpotsItemProps {
    group: string;
    ageRange: string;
    ageGroup: string;
    availability: string;
    cta: string;
}

const SpotsItem:  React.FC<SpotsItemProps> =  ({ageRange, availability, ageGroup, cta }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
            <article className={styles.testimonial_card}>
                <h2 className={styles.group}>{ageGroup}</h2>
                <h6 className={styles.range}>{ageRange}</h6>
                <p className={styles.availability}>{availability}</p>
                <CTAButton text={cta}/>
            </article>

    );
};

export default SpotsItem;
